module.exports = __webpack_public_path__ + "static/media/save-money.38f715ff.svg";